import { call, put, takeLatest } from 'redux-saga/effects';
import { ILoginRequest } from '../../model/request/auth/ILoginRequest';
import { ILoginVNPTRequest } from '../../model/request/auth/ILoginVNPTRequest';
import IBaseRespone from '../../model/respone/IBaseRespone';
import { authApi } from '../../services/auth/authApi';
import { loginSuccess, loginError, setUserProfile } from './authSlice';

export function* authSaga(): any {
    yield takeLatest('LOGIN_START', loginWorker);
    yield takeLatest('GET_USER_INFO_START', getDetailWorker);
    yield takeLatest('LOGIN_VNPT_START', loginVNPTWorker);
    yield takeLatest('GET_USER_INFO_VNPT_START', getDetailVNPTWorker);
}

function* loginWorker(action: any): any {
    const res: IBaseRespone = yield call(authApi.logIn, action.payload as ILoginRequest);

    if (res.is_success) {
        yield put(loginSuccess(res.data));
    } else {
        yield put(loginError(undefined));
    }

    yield put({ type: 'GET_USER_INFO_START' });
}

function* getDetailWorker(): any {
    const res: IBaseRespone = yield call([authApi, authApi.getUser]);

    if (res.is_success) {
        yield put(setUserProfile(res.data));
    } else {
        yield put(setUserProfile(undefined));
    }
}

function* loginVNPTWorker(action: any): any {
    const res: IBaseRespone = yield call(authApi.logInVNPT, action.payload as ILoginVNPTRequest);

    if (res.is_success) {
        yield put(loginSuccess(res.data));
    } else {
        yield put(loginError(res.message ?? 'Có lỗi'));
    }

    yield put({ type: 'GET_USER_INFO_VNPT_START' });
}

function* getDetailVNPTWorker(): any {
    const res: IBaseRespone = yield call([authApi, authApi.getUserVNPT]);

    if (res.is_success) {
        yield put(setUserProfile(res.data));
    } else {
        yield put(setUserProfile(undefined));
    }
}
